import { combineReducers } from "redux";

import scheduling from "./scheduling";

export default combineReducers({
  scheduling,
});
